import { useNavigate, useParams, Navigate } from 'react-router-dom';

import { CardShell } from '@shared/ui/CardShell';

import { ClaimCard } from './ClaimCard';

/**
 * Полноценная страница карточки претензии / иска по URL
 * `/agents/statut/claims/:id`. Раньше карточка открывалась как
 * модальное окно — было неудобно листать длинный документ, URL
 * не отражал текущую запись, back-button браузера не работал.
 *
 * Логика:
 *   - useParams() достаёт id из URL;
 *   - если id отсутствует (битый URL) — редиректим на список;
 *   - onClose из ClaimCard (вызывается после удаления претензии)
 *     переводит на список через navigate;
 *   - кнопка «К списку» в CardShell — то же самое поведение.
 */
export function ClaimPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) {
    return <Navigate to="/agents/statut/claims" replace />;
  }

  const back = () => navigate('/agents/statut/claims');

  return (
    <CardShell title="Карточка претензии / иска" onBack={back}>
      <ClaimCard claimId={id} onClose={back} />
    </CardShell>
  );
}
